import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=6707ed7e&scoped=true"
import script from "./DataManagement.vue?vue&type=script&lang=js"
export * from "./DataManagement.vue?vue&type=script&lang=js"
import style0 from "./DataManagement.vue?vue&type=style&index=0&id=6707ed7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707ed7e",
  null
  
)

export default component.exports